<template>
    <div class="modal fade" id="modalDateFilter" tabindex="-1" role="dialog" aria-labelledby="dateFilterLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">                    
                    <h3>Filter documents by date</h3>                
                    <button class="btn btn-lg btn-default float-end" type="button" data-bs-dismiss="modal"><i class="fas fa-lg fa-times" aria-hidden="true"></i></button>        
                </div>
                <div class="modal-body">
                    <div v-if="error.status" class="alert alert-warning">{{error.message}}</div>
                    <div class="form-row pb-3">			
                        <div class="form-check form-check-inline">
                            <input type="radio" id="singleDate" name="datePick" class="form-check-input" v-on:click="toggleType()" v-model="datePick" value="single">
                            <label class="form-check-label" for="singleDate">A single date</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" id="dateRange" name="datePick" class="form-check-input" v-on:click="toggleType()" v-model="datePick" value="range">
                            <label class="form-check-label" for="dateRange">A date range</label>
                        </div>
                    </div>
                    <div v-if="datePick == 'single'" class="form-row">
                        <div class="col-6 ps-1">
                            <v-date-picker
                            mode="single"
                            v-model="dateOfRecord"                  
                            >
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="input-group form-label-group">
                                    <input type="text"
                                    class="form-control"                    
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    placeholder="Date of record">
                                    <label :class="{'populated': dateOfRecord > ''}">Date of record</label>                                     
                                </div>
                            </template>
                            </v-date-picker> 
                        </div>
                    </div>
                    <div v-if="datePick == 'range'" class="form-row">
                        <div class="col-8 ps-1">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-label-group mb-2">							
                                        <v-date-picker
                                        mode="single"
                                        v-model="dateOfRecordStart"                  
                                        >
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <div class="input-group form-label-group">
                                                <input type="text"
                                                class="form-control"                    
                                                :value="inputValue"
                                                v-on="inputEvents"
                                                placeholder="Start date">
                                                <label :class="{'populated': dateOfRecordStart > ''}">Start date</label>                                     
                                            </div>
                                        </template>
                                        </v-date-picker> 
                                    </div>
                                </div>
                                <div class="col-6">
                                    <v-date-picker
                                    mode="single"
                                    v-model="dateOfRecordEnd"                  
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <div class="input-group form-label-group">
                                            <input type="text"
                                            class="form-control"                    
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            placeholder="End date">
                                            <label :class="{'populated': dateOfRecordEnd > ''}">End date</label>                                     
                                        </div>
                                    </template>
                                    </v-date-picker> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer mt-3">
                    <div class="float-end">                  
                        <button type="button" class="btn btn-primary me-2" :disabled="searchDisabled" v-on:click="doSearch()"><i class="fas fa-search"></i> Search</button>                
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" v-on:click="close()"><i class="fas fa-times"></i> Close</button>                
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            search: '',		
            error: {message: '', status: false},
            datePick: 'single',
            dateOfRecord: false,
            dateOfRecordStart: false,
            dateOfRecordEnd: false
        }
    },
    methods: {
        close: function() {            
            this.error = {message: '', status: false},
            this.datePick = 'single';
            this.dateOfRecord = false;
            this.dateOfRecordStart = false;
            this.dateOfRecordEnd = false;
        },  
        toggleType: function() {
            this.error = {message: '', status: false};
            switch (this.datePick) {
                case 'single':
                    this.dateOfRecordStart = false; 
                    this.dateOfRecordEnd = false;
                break;
                case 'range':
                    this.dateOfRecord = false;
                break;
            }
        }, 
        doSearch: function() {
            switch (this.datePick) {
                case 'single':
                    this.$parent.startDate = this.dateToString(this.dateOfRecord);
                    this.$parent.endDate = this.dateToString(this.dateOfRecord);
                break;
                case 'range':
                    this.$parent.startDate = this.dateToString(this.dateOfRecordStart);
                    this.$parent.endDate = this.dateToString(this.dateOfRecordEnd);
                break;
            }            
            this.close();
        },
        dateToString: function(date) {
            var out = false;
            if (date) {
                var mm = date.getMonth() + 1; // getMonth() is zero-based
                var dd = date.getDate();
                out = [date.getFullYear(), (mm>9 ? '' : '0') + mm, (dd>9 ? '' : '0') + dd].join('');        
            }
            return out;
        }
    },
    computed: {
        searchDisabled: function() {
            var out = false;
            switch (this.datePick) {
                case 'single':
                    if (!this.dateOfRecord) {
                        out = true;
                    } else {                        
                        if  (Object.prototype.toString.call(this.dateOfRecord) !== '[object Date]') {
                            out = true;
                            this.error.status = true;
                            this.error.message = "Date of record must be a valid date in MM/DD/YYYY format";
                        }
                    }
                break;
                case 'range':
                    if (!this.dateOfRecordStart || !this.dateOfRecordEnd) {                        
                        out = true;                            
                    } else {
                        if (Object.prototype.toString.call(this.dateOfRecordStart) !== '[object Date]' ||  Object.prototype.toString.call(this.dateOfRecordEnd) !== '[object Date]') {
                            out = true;
                            this.error.status = true;
                            this.error.message = "Start and end date must be valid dates in MM/DD/YYYY format";
                        } else {
                            if (this.dateToString(this.dateOfRecordEnd) < this.dateToString(this.dateOfRecordStart)) {
                                out = true;
                                this.error.status = true;
                                this.error.message = "Start date must be earlier than end date";
                            }
                        }
                    }
                break;
            }
            return out;
        }
    }
}
</script>
<style>
.modal-footer {
    display: block;
}
</style>